import {
  IRequestServiceMock
} from './index'

export const mockRequestService = (): IRequestServiceMock => ({
  addServiceOrder: jest.fn(),
  addPublicPlanOrder: jest.fn(),
  addPlanOrder: jest.fn(),
  addSolutionOrder: jest.fn(),
  addPromoCodeOrder: jest.fn(),

  getOrderByToken: jest.fn(),
  addConsultationInfo: jest.fn(),
  getOrderHistories: jest.fn(),
  getRequestTravelHistories: jest.fn(),
  appendService: jest.fn(),
  cancelOrder: jest.fn(),
})
